

// reactstrap components
import {  Container, Row } from "reactstrap";

const Login = () => {
  return (
    <>
      <footer className="py-5">
        <Container>
          <Row className="align-items-center justify-content-xl-between">
           
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Login;
